export default __webpack_public_path__ + "static/media/info_2_mobile.f53bc155.jpg";